<db-dialog-wrapper [dialog]="this" [hasCloseButton]="challengeDialog" [canClose]="challengeDialog" [width]="fromPremiumPlugin ? '488px' : (challengeDialog ? '1000px' : '718px')" [height]="fromPremiumPlugin ? '313px' : (challengeDialog ? '578px' : '')">

  <div class="db-from-manager-dialog" *ngIf="!challengeDialog && !fromPremiumPlugin">
    <div class="db-from-manager-dialog__logo"><a href="https://10web.io/"><img src="assets/images/icons/10web_white_bg.svg" alt=""/></a></div>
    <h2>{{(website?.isLocalhost ? 'text_oops' : 'text_congratsFromManager') | dbText}}</h2>
    <p [innerHTML]="'text_congratsFromManagerDesc' | dbText" *ngIf="!website?.isLocalhost"></p>
    <p [innerHTML]="'text_localhostWarning' | dbText" *ngIf="website?.isLocalhost"></p>
    <a class="db-button db-button_info" (click)="letsExplore()"><span [innerHTML]="'text_done_short' | dbText"></span></a>
  </div>

  <div class="db-from-manager-dialog" *ngIf="challengeDialog && !fromPremiumPlugin">
    <h3 [innerHTML]="'text_congratsFromManagerChallenge' | dbText"></h3>
    <h1 [innerHTML]="(website?.isLocalhost ? 'text_oops' : 'text_congratsFromManagerChallengeDesc') | dbText"></h1>
    <p class="db-from-manager-dialog__challange" [innerHTML]="'text_congratsFromManagerChallengeDescMagic' | dbText" *ngIf="!website?.isLocalhost"></p>
    <p class="db-from-manager-dialog__challange" [innerHTML]="'text_localhostWarning' | dbText" *ngIf="website?.isLocalhost"></p>
    <a class="db-button db-button__yellow" (click)="letsExplore()"><span [innerHTML]="'text_addPaymentMethodSubscriptionSuccessButton' | dbText"></span></a>
  </div>

  <div class="db-from-manager-dialog db-from-manager-dialog__from-premium" *ngIf="fromPremiumPlugin">
    <div class="db-from-manager-dialog__logo">
      <img  src="../../assets/images/premium-plugins-logos/{{ premiumPlugin.slug }}.svg"/>
    </div>
    <h2>{{(website?.isLocalhost ? 'text_oops' : 'text_congratsFromManager') | dbText}}</h2>
    <p [innerHTML]="'text_congratsFromManagerPremiumPlugin' | dbText : {premiumPlugin: premiumPlugin.title} " *ngIf="!website?.isLocalhost && premiumPlugin"></p>
    <p [innerHTML]="'text_localhostWarning' | dbText" *ngIf="website?.isLocalhost"></p>
    <a class="db-button db-button_info" (click)="letsExplore()"><span [innerHTML]="'text_gotIt' | dbText"></span></a>
  </div>
</db-dialog-wrapper>
